// ABOUTME: Hawaiian-term glossary shared by every bilingual behavior/action label in the app
// ABOUTME: See issue #1901/#1887 for the general i18n layer this may later adopt

export const bilingualGlossary = {
  star: 'Hōkū',
  triangle: 'Aʻo',
  storm: 'ʻIno',
  heart: 'Aloha',
  approval: 'Hoʻāpono',
  trust: 'Paulele',
  celebration: 'Hoʻolauleʻa',
  celebrate: 'Hauʻoli',
  todaySea: 'Kēia lā kai',
  piko: 'Piko',
  pono: 'Pono',
  kala: 'Kala',
  kuleana: 'Kuleana',
} as const;

export type BilingualTerm = keyof typeof bilingualGlossary;
